import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "controllable-view--container" }
const _hoisted_2 = { class: "controllable-view--view" }
const _hoisted_3 = {
  key: 0,
  class: "controllable-view--view__container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (view, i) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_ctx.modelValue === view.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, view.id, {
                active: _ctx.modelValue,
                views: _ctx.views,
                change: _ctx.change
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 256))
  ]))
}